'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$4() {
  this.bh3 = null;
  this.bh1 = null;
  this.bh2 = false;
  this.bgZ = null;
  this.bh0 = false;
  this.bh4 = false;
  this.bh5 = false;
  this.bh3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$4 as $c_Lpresto_PrestoRouter$$anon$4 };
$p = $c_Lpresto_PrestoRouter$$anon$4.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$4;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$4() {
}
export { $h_Lpresto_PrestoRouter$$anon$4 as $h_Lpresto_PrestoRouter$$anon$4 };
$h_Lpresto_PrestoRouter$$anon$4.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bh3;
});
$p.t = (function() {
  if ((!this.bh2)) {
    this.bh1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bh2 = true;
  }
  return this.bh1;
});
$p.ad = (function() {
  if ((!this.bh0)) {
    this.bgZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bh0 = true;
  }
  return this.bgZ;
});
$p.v = (function() {
  if ((!this.bh5)) {
    this.bh4 = false;
    this.bh5 = true;
  }
  return this.bh4;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$4, "presto.PrestoRouter$$anon$4", ({
  Of: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$4 as $d_Lpresto_PrestoRouter$$anon$4 };
//# sourceMappingURL=presto.-Presto-Router$$anon$4.js.map
